<div id="content">
  <div class="page-title gap-5 items-center!">
    <button mat-flat-button [routerLink]="backLink()" [disabled]="saving()">
      <mat-icon>arrow_back</mat-icon>
      Volver atrás
    </button>

    <h1>{{ page_title }}</h1>
    <div [matTooltip]="!canSubmitWhileClockedIn() ? 'Solo podrás solicitar una ausencia cuando fiches salida.' : ''">
      <button mat-flat-button color="accent" (click)="submit()" [disabled]="!canSubmitWhileClockedIn() || saving()">
        @if (saving()) {
          Guardando…
        } @else {
          Guardar
        }
      </button>
    </div>
  </div>

  <section class="card">
    <!-- Mensaje informativo cuando se ajusta la fecha -->
    @if (dateAdjustmentMessage()) {
      <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 flex items-start gap-3">
        <mat-icon class="text-blue-600">info</mat-icon>
        <div class="flex-1">
          <p class="text-sm text-blue-900 m-0">
            {{ dateAdjustmentMessage() }}
          </p>
        </div>
      </div>
    }

    <form [formGroup]="form" class="flex flex-col gap-8">
      <section class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
        @if (isManageForOthers) {
          <mat-form-field class="bg-white rounded-lg w-full">
            <mat-label>Trabajador</mat-label>
            <mat-select formControlName="user_id">
              @for (worker of workers(); track worker.id) {
                <mat-option [value]="worker.id">{{ worker.name }} {{ worker.surnames }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <div class="flex items-center gap-2 w-full">
          <mat-form-field class="bg-white rounded-lg flex-1">
            <mat-select
              placeholder="Categorías"
              formControlName="working_time_category_id"
              (selectionChange)="onWorkingTimeCategoryChange($event)"
            >
              @for (item of absencesWorkingTimeCategories(); track item.id) {
                <mat-option [value]="item.id">
                  {{ item.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <mat-form-field class="bg-white rounded-lg w-full">
          <mat-label>{{ isAllDay() ? 'Fecha de inicio' : 'Fecha' }}</mat-label>
          <input
            matInput
            [matDatepicker]="startDatePicker"
            formControlName="start_date"
            placeholder="dd/mm/aaaa"
            [min]="minDate()"
            [matTooltip]="isStartDateLocked() ? 'No puedes cambiar el inicio de una ausencia que ya ha comenzado.' : ''"
          />
          <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>

        @if (!isAllDay()) {
          <div class="flex gap-3 w-full">
            <mat-form-field class="bg-white rounded-lg flex-1">
              <mat-label>Hora de inicio</mat-label>
              <input
                matInput
                formControlName="start_time"
                type="time"
                [matTooltip]="isStartDateLocked() ? 'No puedes cambiar el inicio de una ausencia que ya ha comenzado.' : ''"
              />
            </mat-form-field>
            <mat-form-field class="bg-white rounded-lg flex-1">
              <mat-label>Hora de fin</mat-label>
              <input matInput formControlName="end_time" type="time" />
            </mat-form-field>
          </div>
        }

        @if (isAllDay()) {
          <mat-form-field class="bg-white rounded-lg w-full">
            <mat-label>Fecha de fin</mat-label>
            <input
              matInput
              [matDatepicker]="endDatePicker"
              formControlName="end_date"
              placeholder="dd/mm/aaaa"
              [min]="$safeNavigationMigration(form.get('start_date')?.value)"
            />
            <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field>
        }

        <mat-form-field class="bg-white rounded-lg w-full col-span-1 sm:col-span-2 lg:col-span-3">
          <textarea matInput placeholder="Justificación" formControlName="justification" rows="4"></textarea>
        </mat-form-field>
      </section>

      @if (originalHasDocument()) {
        <section class="flex items-center gap-2 mt-2">
          <mat-checkbox [checked]="keepDocument()" (change)="keepDocument.set($event.checked)" color="accent">
            Mantener archivo en la modificación
          </mat-checkbox>
          <mat-icon
            class="text-gray-500 cursor-help text-[18px]!"
            matTooltip="Al marcar esta casilla, el archivo actual se mantendrá en la solicitud de ausencia. De lo contrario, el archivo será eliminado y deberás volver a subir la documentación."
          >
            help_outline
          </mat-icon>
        </section>
      }
    </form>
  </section>

  <section class="card">
    <div class="mt-8">
      <app-absence-categories-legend [categoryId]="$safeNavigationMigration(selectedCategory()?.id)"></app-absence-categories-legend>
    </div>
  </section>
</div>
